import { Box } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { useTwoColumnContainerStyles } from "../TwoColumnContainer.styles";
import { useLeftColumnStyles } from "./LeftColumn.styles";

export interface LeftColumnProps {
    children: React.ReactNode;
}

function LeftColumn(props: LeftColumnProps) {
    const twoColumnContainerStyles = useTwoColumnContainerStyles();
    const styles = useLeftColumnStyles();
    return (
        <Grid sx={twoColumnContainerStyles.grid} size={{ md: 6 }}>
            <Box sx={[twoColumnContainerStyles.commonContainer, styles.leftContainer]}>{props.children}</Box>
        </Grid>
    );
}

export default LeftColumn;
